// extracted by mini-css-extract-plugin
export default {"toggleWrapper":"toggle_wrapper-module___toggleWrapper___b86412e5","label":"toggle_wrapper-module___label___d5259289"};